import { useEffect } from 'react';
import { clsx } from 'clsx';
import { Button } from '@/ui/components/Button';
import { OfferReservationBanner } from '@/components/OfferReservationBanner';
import { ArrowRightIcon, ShieldCheckFillIcon } from '@/assets/icons';
import { OceanCreditLogoWhiteYellow, VoltLogoCircle } from '@/assets/logos';
import { externalUrls } from '@/constants/urls';
import { trackingService, useTrackOnboardingCompleted } from '@/lib/tracking';
import styles from './AppRedirectPage.module.scss';

function AppRedirectPage() {
  useTrackOnboardingCompleted();

  useEffect(() => {
    trackingService.trackEvent('app_redirect_screen_shown');
  }, []);

  const handleOpenApp = () => {
    window.location.href = externalUrls.volt.appDownload;
  };

  return (
    <div className={styles.root}>
      <OfferReservationBanner />

      <div className={styles.content}>
        <div className={styles.cardShell}>
          <div className={styles.card}>
            <div className={styles.cardOverlay} />

            <div className={styles.cardHeader}>
              <div className={styles.avatar}>
                <VoltLogoCircle className={styles.avatarIcon} />
              </div>
              <div className={styles.headerText}>
                <p className={styles.offerLabel}>Oferta ta</p>
                <div className={styles.poweredBy}>
                  <span>Powered by</span>
                  <OceanCreditLogoWhiteYellow className={styles.poweredByLogo} />
                </div>
              </div>
            </div>

            <div className={styles.skeletonRow}>
              <div className={clsx(styles.skeleton, styles.skeletonBadge)} />
            </div>

            <div className={styles.cardBottom}>
              <div className={styles.cardBottomGroup}>
                <div className={clsx(styles.skeleton, styles.skeletonLabel)} />
                <div className={clsx(styles.skeleton, styles.skeletonAmount)} />
              </div>
              <div className={clsx(styles.skeleton, styles.skeletonAside)} />
            </div>
          </div>
        </div>

        <div className={styles.textContainer}>
          <h1 className={styles.title}>Vezi oferta ta în <br />  aplicație</h1>
          <p className={styles.description}>
            Descarcă Volt și vezi oferta ta acum.
          </p>
        </div>

        <div className={styles.trustChip}>
          <ShieldCheckFillIcon className={styles.trustIcon} />
          <p className={styles.trustText}>
            Verificarea ofertei nu îți afectează scorul
          </p>
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <Button
          trackingId="app_redirect_open_app"
          variant="filled"
          text="Deschide oferta în aplicație"
          rightIcon={<ArrowRightIcon />}
          className={styles.button}
          onClick={handleOpenApp}
        />
      </div>
    </div>
  );
}

export default AppRedirectPage;
